import { COLORS } from "../../../constants";
import { HALO } from "../../../constants/colors";
export var tabStyles = {
    color: COLORS.P_HIGH_EMPHASIS,
    px: 2.5,
    py: 3,
    fontWeight: 400,
    opacity: "1 !important",
    fontSize: "14px",
    lineHeight: "20px",
    "&:focus-visible": {
        boxShadow: HALO,
    },
    "&:hover": {
        color: COLORS.P_MED_EMPHASIS,
    },
    "&:active": {
        color: COLORS.P_MED_LOW_EMPHASIS,
    },
    "&.Mui-disabled": {
        color: COLORS.P_DISABLED,
    },
    "&.Mui-selected": {
        color: "primary.main",
        fontWeight: 600,
        "&:focus-visible": {
            boxShadow: "none",
        },
    },
};
export var titleTabStyles = {
    color: COLORS.P_MED_LOW_EMPHASIS,
    px: 3,
    py: 2,
    fontWeight: 400,
    opacity: "1 !important",
    fontSize: "24px",
    lineHeight: "28px",
    "&:focus-visible": {
        boxShadow: HALO,
    },
    "&:hover": {
        color: COLORS.P_MED_EMPHASIS,
    },
    "&:active": {
        color: COLORS.P_MED_HIGH_EMPHASIS,
    },
    "&.Mui-disabled": {
        color: COLORS.P_DISABLED,
    },
    "&.Mui-selected": {
        color: "black",
        fontWeight: 600,
        "&:focus-visible": {
            boxShadow: "none",
        },
    },
};
